import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const PORTRAIT = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/bxuh4n7u_561032059_1225760372926078_514483854794351507_n.jpg";
const CHILD = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/07vjk0de_527494542_18523233646047014_4338066449527016628_n.jpg";
const RAT = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/baxfjh5p_526299222_18523035577047014_7429250495539061488_n.jpg";
const TRANSFORM = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/nfhxetpm_519041749_18519342406047014_745421865542459861_n.jpg";
const COUPLE = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/u4jwi6x0_623068918_18558530164047014_8050591893448201473_n.jpg";
const MEME = "https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/wxgjxvs5_601558215_18550759387047014_6339306814612963522_n.jpg";

const values = [
  ["Autenticità", "Nessuna formula magica. Solo lavoro vero, onesto e su misura."],
  ["Ascolto", "Ogni percorso parte da te: dalle tue parole e dai tuoi silenzi."],
  ["Concretezza", "Obiettivi chiari, azioni misurabili, risultati che si vedono."],
  ["Umanità", "Un approccio caldo, mai freddo o standardizzato."],
];

export const About = () => (
  <div className="pt-32 pb-24 relative z-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="img-zoom rounded-2xl overflow-hidden border border-white/10">
            <img src={PORTRAIT} alt="Mirko Scravaglieri" className="w-full h-[560px] object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="eyebrow mb-4">Chi sono</p>
          <h1 className="font-display text-4xl sm:text-5xl text-white leading-tight mb-8">
            Ciao, sono Mirko. <span className="gold-gradient italic">Il tuo alleato</span> nel cambiamento.
          </h1>
          <div className="space-y-5 text-zinc-300 leading-relaxed">
            <p>Da oltre dieci anni accompagno persone e aziende in percorsi di crescita che uniscono metodo e umanità. La mia storia nasce dal campo: vendita, formazione e leadership vissute sul serio, prima di diventare mental coach.</p>
            <p>Credo che dentro ognuno ci siano risorse straordinarie, spesso addormentate. Il mio compito non è darti risposte preconfezionate, ma aiutarti a farle emergere attraverso domande potenti, ascolto profondo e azioni concrete.</p>
            <p>Lavoro con privati che vogliono ritrovare direzione e con aziende che desiderano team più motivati e performanti. Sempre con lo stesso principio: rispetto per la persona, prima di tutto.</p>
          </div>
          <figure className="mt-8 flex items-center gap-4">
            <img src={CHILD} alt="Mirko da bambino" className="h-24 w-24 rounded-xl object-cover border border-white/10" />
            <figcaption className="text-zinc-500 text-sm italic max-w-xs">Tutto è iniziato da qui: la stessa energia e curiosità di allora, oggi al servizio della crescita delle persone.</figcaption>
          </figure>
        </Reveal>
      </div>

      <div className="mt-24">
        <Reveal><h2 className="font-display text-3xl sm:text-4xl text-white mb-12">I miei valori</h2></Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map(([t, d], i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="hover-lift h-full bg-[#121212] border border-white/10 rounded-xl p-7">
                <span className="font-display text-3xl gold-text">0{i + 1}</span>
                <h3 className="text-lg text-white mt-4 mb-2">{t}</h3>
                <p className="text-zinc-400 text-sm leading-relaxed">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Manifesto — il topo */}
      <div className="mt-24">
        <Reveal>
          <div className="grid lg:grid-cols-2 gap-0 bg-[#121212] border border-[#C19A5B]/30 rounded-2xl overflow-hidden">
            <div className="img-zoom h-72 lg:h-auto">
              <img src={RAT} alt="La potenza dell'animo" className="w-full h-full object-cover" data-testid="about-manifesto-img" />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <span className="eyebrow mb-4">Il mio manifesto</span>
              <blockquote className="font-display text-2xl sm:text-3xl text-white leading-snug">
                "La potenza dell'animo si vede proprio quando tutti ti dicono che <span className="gold-gradient italic">non puoi</span>… e tu lo fai comunque."
              </blockquote>
              <p className="text-zinc-400 mt-6 leading-relaxed">Come nella storia di quel piccolo topo che sognava in grande: non conta da dove parti, ma quanto sei disposto a crederci. È questa la scintilla che accendo in ogni percorso.</p>
              <p className="text-[#C19A5B] mt-4 font-medium">— Mirko Scravaglieri</p>
            </div>
          </div>
        </Reveal>
      </div>

      {/* Trasformazione */}
      <div className="mt-24">
        <Reveal><h2 className="font-display text-3xl sm:text-4xl text-white mb-4">La crescita è un percorso</h2></Reveal>
        <Reveal delay={0.1}><p className="text-zinc-400 mb-10 max-w-xl">Ogni cambiamento richiede tempo, costanza e la scelta quotidiana di migliorarsi.</p></Reveal>
        <Reveal delay={0.15}>
          <div className="rounded-2xl overflow-hidden border border-white/10">
            <img src={TRANSFORM} alt="La trasformazione di Mirko" className="w-full object-cover" data-testid="about-transform-img" />
          </div>
        </Reveal>
      </div>

      {/* Momenti */}
      <div className="mt-24">
        <Reveal><h2 className="font-display text-3xl sm:text-4xl text-white mb-12">Momenti & convinzioni</h2></Reveal>
        <div className="grid md:grid-cols-2 gap-6">
          <Reveal>
            <div className="img-zoom h-full rounded-2xl overflow-hidden border border-white/10">
              <img src={COUPLE} alt="Mirko nella vita" className="w-full h-full object-cover" data-testid="about-couple-img" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="img-zoom h-full rounded-2xl overflow-hidden border border-white/10">
              <img src={MEME} alt="Il ricco si forma, il povero si distrae" className="w-full h-full object-cover" data-testid="about-meme-img" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </div>
);

export default About;
